const carRental = {
  carRental: "השכרת רכב", // translated
  carRentals: "השכרת רכב", // translated
  pickUpPoint: "נקודת איסוף", // translated
  dropOffPoint: "נקודת ירידה", // translated
  pickUpDate: "בחר תאריך", // translated
  dropOffDate: "תאריך החזרה", // translated
  pickUp: "לאסוף", // translated
  dropOff: "ירידה", // translated
  edit: "לַעֲרוֹך", // translated
  fuelPolicy: "מדיניות דלק", // translated
  pickUpLocation: "בחר מיקום", // translated
  mileage: "מִספָּר הַמַיִלִים", // translated
  transmission: "הפצה", // translated
  airCondition: "מיזוג אוויר", // translated
  minimumAge: "גיל מינימום", // translated
  maximumAge: "גיל מקסימום", // translated
  providerAddress: "כתובת הספק", // translated
  providerPhone: "טלפון ספק", // translated
  driverInfo: "מידע על נהג", // translated
  driversInfo: "מידע על הנהג", // translated
  differentDropOff: "הורדה במקום אחר", // translated
  maxPassengers: "מקסימום נוסעים", // translated
  budget: "תַקצִיב", // translated
  provider: "ספק", // translated
  carModel: "דגם רכב", // translated
  numOfDoors: "מספר דלתות", // translated
  fuelType: "סוג דלק", // translated
  duePickUp: "מועד באיסוף", // translated
  toViewTermsAndCondPDF: "כדי להציג את התנאים וההגבלות הרלוונטיים של CARNECT, בבקשה", // translated
  carRentalRate: "תעריף השכרת רכב", // translated
  driverAge: "גיל הנהג", // translated
  dueNow: "מועד עתה", // translated
  workingHours: "שעות עבודה", // translated
  toViewOfferPDF: "לצפייה במסמך PDF המכיל את כל תנאי ההשכרה של הצעה זו, בבקשה", // translated
  driverNationality: "אזרחות הנהג", // translated
};


export default carRental;
